// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container{
  display: flex;
  align-items: center;
}

.border{
  border-bottom: 1px solid #ffffff;
  width: 100%;
}

.content {
  padding: 0 10px 0 10px;
}


.sidebar-container {
  position: fixed;
}


.sidebar {
  background-color: var(--black);
  width: 3.5rem;
  height: 80vh;
  margin-top: 1rem;
  border-radius: 0 30px 30px 0;
  padding: 1rem 0;
  transition: width 0.5s ease;
}

.sidebar.expanded {
  width: 12rem;
}

.logo img {
  width: 100%;
  height: auto;
}


.menu {
  list-style: none;
  padding: 2rem 0;
  transition: width 0.5s ease;
}


.menu.expanded {
  width: 12rem;
}


.menu li {
  padding-left: 1rem;
}


.menu li a {
  display: flex;
  align-items: center;
}


.menu li a img {
  width: 1.2rem;
  height: auto;
  filter: invert(92%) sepia(4%) saturate(1033%) hue-rotate(169deg) brightness(78%) contrast(85%);
}


.menu li a .show {
  display: block;
  margin-left: 1.5rem;
}


.menu li a .hide {
  display: none;

}
.profile {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0;
  transition: all 0.3s ease;
}

.profile.expanded {
  width: 14rem;
  margin-left: 9rem;
}

.profile img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
}

.profile .show {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile .hide {
    display: none;
}

.name h4 {
  display: inline-block;
}

.logout img {
  width: 100%;
  height: auto;
  filter: invert(15%) sepia(70%) saturate(6573%) hue-rotate(2deg) brightness(100%) contrast(126%);
    transition: all 0.3s ease;
}

.logout:hover img {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/ui/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;;AAGA;EACE,YAAY;AACd;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,8FAA8F;AAChG;;;AAGA;EACE,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,aAAa;;AAEf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+FAA+F;IAC7F,yBAAyB;AAC7B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container{\n  display: flex;\n  align-items: center;\n}\n\n.border{\n  border-bottom: 1px solid #ffffff;\n  width: 100%;\n}\n\n.content {\n  padding: 0 10px 0 10px;\n}\n\n\n.sidebar-container {\n  position: fixed;\n}\n\n\n.sidebar {\n  background-color: var(--black);\n  width: 3.5rem;\n  height: 80vh;\n  margin-top: 1rem;\n  border-radius: 0 30px 30px 0;\n  padding: 1rem 0;\n  transition: width 0.5s ease;\n}\n\n.sidebar.expanded {\n  width: 12rem;\n}\n\n.logo img {\n  width: 100%;\n  height: auto;\n}\n\n\n.menu {\n  list-style: none;\n  padding: 2rem 0;\n  transition: width 0.5s ease;\n}\n\n\n.menu.expanded {\n  width: 12rem;\n}\n\n\n.menu li {\n  padding-left: 1rem;\n}\n\n\n.menu li a {\n  display: flex;\n  align-items: center;\n}\n\n\n.menu li a img {\n  width: 1.2rem;\n  height: auto;\n  filter: invert(92%) sepia(4%) saturate(1033%) hue-rotate(169deg) brightness(78%) contrast(85%);\n}\n\n\n.menu li a .show {\n  display: block;\n  margin-left: 1.5rem;\n}\n\n\n.menu li a .hide {\n  display: none;\n\n}\n.profile {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 0;\n  transition: all 0.3s ease;\n}\n\n.profile.expanded {\n  width: 14rem;\n  margin-left: 9rem;\n}\n\n.profile img {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n}\n\n.profile .show {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.profile .hide {\n    display: none;\n}\n\n.name h4 {\n  display: inline-block;\n}\n\n.logout img {\n  width: 100%;\n  height: auto;\n  filter: invert(15%) sepia(70%) saturate(6573%) hue-rotate(2deg) brightness(100%) contrast(126%);\n    transition: all 0.3s ease;\n}\n\n.logout:hover img {\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
